





























































































import { Component, Prop, Vue } from "vue-property-decorator";

export default {
  data() {
    return {
      pageState: 0,
      top: "",
      allNews: [],
      searchForm: {},
      urls: [],
      pgs: []
    };
  },
  methods: {
    formatDate(longTypeDate, fmt) {
      var date = new Date();
      date.setTime(longTypeDate);
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds()
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          );
        }
      }
      return fmt;
    },
    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    },
    paddingPageData(data) {
      this.urls = data.data.banners;
      this.top = data.data.top;
      this.allNews = data.data.allNews;
      this.pgs = data.data.pgs;
    }
  },
  mounted() {}
};
